export const deviceSize = {
  sm: 576,

  // testing with md and lg the same in order to reduce the number of breakpoints
  // and therefore making testing and maintenance easier
  md: 992, //768,
  lg: 992, //992
  xl: 1200,
  xxl: 1400,
  chonk: 1600,
};

export const size = {
  sm: `${deviceSize.sm}px`,
  md: `${deviceSize.md}px`,
  lg: `${deviceSize.lg}px`,
  xl: `${deviceSize.xl}px`,
  xxl: `${deviceSize.xxl}px`,
  chonk: `${deviceSize.chonk}px`,
};

export const device = {
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
  chonk: `(min-width: ${size.chonk})`,
};

export const deviceMinMaxWidth = {
  isSm: `(min-width: ${size.sm}) and (max-width: ${size.md})`,
  isMd: `(min-width: ${size.md}) and (max-width: ${size.lg})`,
  isLg: `(min-width: ${size.lg}) and (max-width: ${size.xl})`,
  isXl: `(min-width: ${size.xl}) and (max-width: ${size.xxl})`,
  isXxl: `(min-width: ${size.xxl}) and (max-width: ${size.chonk})`,
  isChonk: `(min-width: ${size.chonk})`,
};

export const deviceMaxWidth = {
  sm: `(max-width: ${size.sm})`,
  md: `(max-width: ${size.md})`,
  lg: `(max-width: ${size.lg})`,
  xl: `(max-width: ${size.xl})`,
  xxl: `(max-width: ${size.xxl})`,
  chonk: `(max-width: ${size.chonk})`,
};
